module.exports = __webpack_public_path__ + "static/media/speedometer-icon@2x.9be99556.png";